import React from 'react';
import styled from "styled-components";
import {
    GridCol, GridRow, Paragraph, Header,
} from 'govuk-react';
import {
    CookieMessageContainer,
    InnerWrapper,
    Actions,
    Bttns
} from './styles';

import { SPACING } from '@govuk-react/constants';

const Introduction = styled('div')({
    paddingTop: 0,
    paddingBottom: SPACING.SCALE_2
});

function CookiesMessage() {
    return (
            <CookieMessageContainer>
                <InnerWrapper>
                    <GridRow>
                        <GridCol columnTwoThirds>
                            <Introduction>
                                <Header level={2}>Tell us whether you accept cookies</Header>
                                <Paragraph>
                                    We use [cookies to collect information](#).  about how you use GOV.UK.
                                    We use this information to make the website work as well as
                                    possible and improve government services.
                                </Paragraph>
                            </Introduction>
                        </GridCol>
                    </GridRow>
                    <GridRow>
                        <GridCol columnTwoThirds>
                                <Actions>
                                    <Bttns>Accept all cookies</Bttns>
                                    <Bttns>Set cookie preferences</Bttns>
                                </Actions>
                        </GridCol>
                    </GridRow>
                </InnerWrapper>
            </CookieMessageContainer>
    );
}

export default CookiesMessage;